import { useEffect, useState } from "react";
import { getDocuments } from "../../services/admin.document.service";
import DriverDocumentRow from "./DriverDocumentRow";
import {
  getDriverDocuments,
  uploadDriverDocument,
} from "../../services/driver.document.service";
import DriverDocumentUploadModal from "./DriverDocumentUploadModal";
import DriverDocumentViewerModal from "./DriverDocumentViewerModal";

export default function DriverDocumentsSection({ driver }) {
  const [types, setTypes] = useState([]);
  const [driverDocs, setDriverDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploadTarget, setUploadTarget] = useState(null);
  const [viewFiles, setViewFiles] = useState(null);

  useEffect(() => {
    if (driver?.id) load();
  }, [driver.id]);
  function handleUpload(doc) {
    setUploadTarget({
      ...doc,
      driverId: driver.id,
    });
  }

  function handleView(files) {
    setViewFiles(files);
  }
  async function handleSubmit(formData) {
    try {
      await uploadDriverDocument(formData);
      setUploadTarget(null);
      load();
    } catch (e) {
      console.error(e);
    }
  }
  async function load() {
    try {
      const t = await getDocuments();
      const d = await getDriverDocuments(driver.id);

      setTypes(t || []);
      setDriverDocs(d || []);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="docSkeleton">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="docSkeletonRow" />
        ))}
      </div>
    );
  }

  const merged = types.map((type) => {
    const files = driverDocs.filter((doc) => doc.id_document === type.id);

    return {
      ...type,
      files,
      uploaded: files.length > 0,
    };
  });

  const total = merged.length;
  const done = merged.filter((d) => d.uploaded).length;

  return (
    <div>
      <div className="docProgressWrapper">
        <div className="docProgressText">
          {done} / {total} documents complétés
        </div>

        <div className="docProgress">
          <div style={{ width: `${(done / total) * 100}%` }} />
        </div>
      </div>

      <div className="docList">
        {merged.map((doc) => (
          <DriverDocumentRow
            key={doc.id}
            doc={doc}
            onUpload={handleUpload}
            onView={handleView}
          />
        ))}
      </div>

      <DriverDocumentViewerModal
        open={!!viewFiles}
        files={viewFiles || []}
        onClose={() => setViewFiles(null)}
      />

      <DriverDocumentUploadModal
        open={!!uploadTarget}
        docType={uploadTarget}
        onClose={() => setUploadTarget(null)}
        onSubmit={handleSubmit}
      />
    </div>
  );
}
